import {makeStyles, mergeClasses} from "@fluentui/react-components";
import React, {useEffect, useState} from "react";
import AlertDialog from "./AlertDialog";
import InquiryDialog from "./InquiryDialog";
import {useUserStore} from "../../../../stores/useUserStore";
import {pinkTheme} from "../../../../styles/mission/theme";
import bellIcon from "../../../../assets/icons/ic_bell.svg"
import { Image } from '@fluentui/react-components'

const useStyles = makeStyles({
    titleBarRoot: {
        position: 'fixed',
        top:0,
        left: 0,
        right: 0,
        zIndex: 30,
    },
    titleStyle: {
        fontSize: 'x-large',
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'center',
        padding: '1rem',
    },
    campaignTitleStyle: {
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '0.5rem',
        backgroundColor: 'white',
        borderBottom: `2px solid ${pinkTheme.outliendBtn}`,
        position: 'relative',
    },
    alertBtn: {
        cursor: 'pointer',
        position: 'absolute',
        top: '60%',
        right: '1rem',
        transform: 'translateY(-50%)',
    }
})

interface TitleBarProps {
    title:string,
    campaignTitle:string,
    primaryColor: string,
    className?: string;
    style?: React.CSSProperties;
}

export default function TitleBar({title, campaignTitle, primaryColor,className,style}:TitleBarProps)  {
    const styles = useStyles()
    const { userId, shoppingPathJointId } = useUserStore()

    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false)
    const [isSubmit, setIsSubmit] = useState(false)

    const closeDialog = () => setIsDialogOpen(false)
    const openDialog = () => setIsDialogOpen(true)
    const closeAlertDialog = () => setIsAlertDialogOpen(false)
    const openAlertDialog = () => setIsAlertDialogOpen(true)

    useEffect(() => {
        if (isSubmit) {
            setIsSubmit(false)
        }
    }, [isSubmit])

    return (
        <div className={styles.titleBarRoot}>
            {/*<div className={styles.titleStyle} style={{backgroundColor: primaryColor}}>*/}
            {/*    {title}*/}
            {/*</div>*/}
            <div
                className={mergeClasses(styles.campaignTitleStyle,className)}
                style={style}
            >
                {campaignTitle}
                {
                    userId && shoppingPathJointId && (
                    <>
                        <div onClick={openDialog} className={styles.alertBtn}>
                            <Image alt={"문의 아이콘"} src={bellIcon} width={25} height={25} />
                        </div>
                        <InquiryDialog
                            isOpen={isDialogOpen}
                            onClose={closeDialog}
                            setIsSubmit={() => setIsSubmit(true)}
                            userId={userId}
                            shoppingPathJointId={shoppingPathJointId}
                            primaryColor={primaryColor}
                        />
                    </>
                    )
                }
            </div>
            <AlertDialog
                title={'완료'}
                description={'문의 사항 제출되었습니다.'}
                isOpen={isAlertDialogOpen}
                onClose={closeAlertDialog}
                src={null}
                primaryColor={primaryColor}
            />
        </div>
    );
}